<mat-sidenav-container class="container">
    <mat-sidenav class="sidenav" mode="side" opened fixedInViewport="true" fixedTopGap="0">
        <mat-nav-list class="nav-list">
            <a mat-list-item routerLink="/">
                <i class="material-icons">
                    home
                </i>
                Início
            </a>
            <!-- <a mat-list-item  routerLink="/consoles">
                <i class="material-icons">
                    videowine_asset
                </i>
                Consoles
            </a> -->
            <a mat-list-item routerLink="/wines">
                <i class="material-icons">
                    gamepad
                </i>
                Vinhos
            </a>
            <a mat-list-item routerLink="/users">
                <i class="material-icons">
                    person
                </i>
                Usuários
            </a>
        </mat-nav-list>
        <div class="footer">
            <div>
                COM222
            </div>
            <div>
                Desenvolvimento Web
            </div><br>
            <div>
                <b> UNIFEI </b>
            </div>
        </div>
    </mat-sidenav>
    <mat-sidenav-content class="content">
        <router-outlet></router-outlet>
    </mat-sidenav-content>
</mat-sidenav-container>